import { reduce } from "lodash-es";
import L from "leaflet";

const legendRanges = {
  concentration: {
    forecast: {
      0: "#0000FF",
      0.05: "#0033FF",
      "0.10": "#0066FF",
      0.15: "#0099FF",
      "0.20": "#00CCFF",
      0.25: "#00FFFF",
      "0.30": "#00FFCC",
      0.35: "#00FF99",
      "0.40": "#00FF66",
      0.45: "#00FF33",
      "0.50": "#00FF00",
      0.55: "#33FF00",
      "0.60": "#66FF00",
      0.65: "#99FF00",
      "0.70": "#CCFF00",
      0.75: "#FFFF00",
      "0.80": "#FFCC00",
      0.85: "#FF9900",
      "0.90": "#FF6600",
      0.95: "#FF3300",
      "1.00": "#FF0000",
    },
    history: {
      0: "#0000FF",
      5: "#0033FF",
      10: "#0066FF",
      15: "#0099FF",
      20: "#00CCFF",
      25: "#00FFFF",
      30: "#00FFCC",
      35: "#00FF99",
      40: "#00FF66",
      45: "#00FF33",
      50: "#00FF00",
      55: "#33FF00",
      60: "#66FF00",
      65: "#99FF00",
      70: "#CCFF00",
      75: "#FFFF00",
      80: "#FFCC00",
      85: "#FF9900",
      90: "#FF6600",
      95: "#FF3300",
      100: "#FF0000",
    },
    irregular: {
      0: "#0000FF",
      5: "#0033FF",
      10: "#0066FF",
      15: "#0099FF",
      20: "#00CCFF",
      25: "#00FFFF",
      30: "#00FFCC",
      35: "#00FF99",
      40: "#00FF66",
      45: "#00FF33",
      50: "#00FF00",
      55: "#33FF00",
      60: "#66FF00",
      65: "#99FF00",
      70: "#CCFF00",
      75: "#FFFF00",
      80: "#FFCC00",
      85: "#FF9900",
      90: "#FF6600",
      95: "#FF3300",
      100: "#FF0000",
    },
  },
  thickness: {
    forecast: {
      0: "#0000FF",
      0.25: "#0033FF",
      0.5: "#0066FF",
      0.75: "#0099FF",
      "1.0": "#00CCFF",
      1.25: "#00FFFF",
      1.5: "#00FFCC",
      1.75: "#00FF99",
      "2.0": "#00FF66",
      2.25: "#00FF33",
      2.5: "#00FF00",
      2.75: "#33FF00",
      "3.0": "#66FF00",
      3.25: "#99FF00",
      3.5: "#CCFF00",
      3.75: "#FFFF00",
      "4.0": "#FFCC00",
      4.25: "#FF9900",
      4.5: "#FF6600",
      4.75: "#FF3300",
      "5.0": "#FF0000",
    },
    history: {
      0: "#0000FF",
      0.25: "#0033FF",
      0.5: "#0066FF",
      0.75: "#0099FF",
      "1.0": "#00CCFF",
      1.25: "#00FFFF",
      1.5: "#00FFCC",
      1.75: "#00FF99",
      "2.0": "#00FF66",
      2.25: "#00FF33",
      2.5: "#00FF00",
      2.75: "#33FF00",
      "3.0": "#66FF00",
      3.25: "#99FF00",
      3.5: "#CCFF00",
      3.75: "#FFFF00",
      "4.0": "#FFCC00",
      4.25: "#FF9900",
      4.5: "#FF6600",
      4.75: "#FF3300",
      "5.0": "#FF0000",
    },
    irregular: {
      0: "#0000FF",
      0.25: "#0033FF",
      0.5: "#0066FF",
      0.75: "#0099FF",
      "1.0": "#00CCFF",
      1.25: "#00FFFF",
      1.5: "#00FFCC",
      1.75: "#00FF99",
      "2.0": "#00FF66",
      2.25: "#00FF33",
      2.5: "#00FF00",
      2.75: "#33FF00",
      "3.0": "#66FF00",
      3.25: "#99FF00",
      3.5: "#CCFF00",
      3.75: "#FFFF00",
      "4.0": "#FFCC00",
      4.25: "#FF9900",
      4.5: "#FF6600",
      4.75: "#FF3300",
      "5.0": "#FF0000",
    },
  },
  route: {
    forecast: {
      "-50": "#FF0000",
      "-46": "#FF2200",
      "-42": "#FF4400",
      "-38": "#FF6600",
      "-34": "#FF8800",
      "-30": "#FFAA00",
      "-26": "#FFCC00",
      "-22": "#FFEE00",
      "-18": "#FFFF00",
      "-14": "#EEFF00",
      "-10": "#CCFF00",
      "-6": "#AAFF00",
      "-2": "#88FF00",
      0: "#66FF00",
      2: "#44FF00",
      6: "#22FF00",
      10: "#00FF00",
      14: "#00DD44",
      18: "#00BB88",
      22: "#0099BB",
      26: "#0077EE",
      30: "#0055FF",
    },
    history: {
      "-50": "#FF0000",
      "-46": "#FF2200",
      "-42": "#FF4400",
      "-38": "#FF6600",
      "-34": "#FF8800",
      "-30": "#FFAA00",
      "-26": "#FFCC00",
      "-22": "#FFEE00",
      "-18": "#FFFF00",
      "-14": "#EEFF00",
      "-10": "#CCFF00",
      "-6": "#AAFF00",
      "-2": "#88FF00",
      0: "#66FF00",
      2: "#44FF00",
      6: "#22FF00",
      10: "#00FF00",
      14: "#00DD44",
      18: "#00BB88",
      22: "#0099BB",
      26: "#0077EE",
      30: "#0055FF",
    },
    irregular: {
      "-50": "#FF0000",
      "-46": "#FF2200",
      "-42": "#FF4400",
      "-38": "#FF6600",
      "-34": "#FF8800",
      "-30": "#FFAA00",
      "-26": "#FFCC00",
      "-22": "#FFEE00",
      "-18": "#FFFF00",
      "-14": "#EEFF00",
      "-10": "#CCFF00",
      "-6": "#AAFF00",
      "-2": "#88FF00",
      0: "#66FF00",
      2: "#44FF00",
      6: "#22FF00",
      10: "#00FF00",
      14: "#00DD44",
      18: "#00BB88",
      22: "#0099BB",
      26: "#0077EE",
      30: "#0055FF",
    },
  },
  remote: {
    forecast: {
      0: "#0000FF",
      0.05: "#0033FF",
      "0.10": "#0066FF",
      0.15: "#0099FF",
      "0.20": "#00CCFF",
      0.25: "#00FFFF",
      "0.30": "#00FFCC",
      0.35: "#00FF99",
      "0.40": "#00FF66",
      0.45: "#00FF33",
      "0.50": "#00FF00",
      0.55: "#33FF00",
      "0.60": "#66FF00",
      0.65: "#99FF00",
      "0.70": "#CCFF00",
      0.75: "#FFFF00",
      "0.80": "#FFCC00",
      0.85: "#FF9900",
      "0.90": "#FF6600",
      0.95: "#FF3300",
      "1.00": "#FF0000",
    },
    history: {
      0: "#0000FF",
      5: "#0033FF",
      10: "#0066FF",
      15: "#0099FF",
      20: "#00CCFF",
      25: "#00FFFF",
      30: "#00FFCC",
      35: "#00FF99",
      40: "#00FF66",
      45: "#00FF33",
      50: "#00FF00",
      55: "#33FF00",
      60: "#66FF00",
      65: "#99FF00",
      70: "#CCFF00",
      75: "#FFFF00",
      80: "#FFCC00",
      85: "#FF9900",
      90: "#FF6600",
      95: "#FF3300",
      100: "#FF0000",
    },
  },
  temperature: {
    forecast: {
      "-40": "#0000FF",
      "-30": "#4169E1",
      "-20": "#1E90FF",
      "-10": "#87CEFA",
      0: "#ffffff",
      10: "#FFFF00",
      20: "#FFD700",
      30: "#FF8C00",
      40: "#FF0000",
      50: "#B22222",
      60: "#8B0000",
    },
    history: {
      "-40": "#0000FF",
      "-30": "#4169E1",
      "-20": "#1E90FF",
      "-10": "#87CEFA",
      0: "#ffffff",
      10: "#FFFF00",
      20: "#FFD700",
      30: "#FF8C00",
      40: "#FF0000",
      50: "#B22222",
      60: "#8B0000",
    },
  },
};

export const layerNames = {
  concentration: "海冰密集度",
  thickness: "海冰厚度",
  temperature: "温度",
  wind: "风速",
  route: "最优航道",
};

export const legendNames = {
  concentration: "海冰密集度",
  thickness: "海冰厚度",
  temperature: "温度",
  wind: "风速",
  route: "综合航行风险值",
  remote: "海冰密集度",
};

export const panelNames = {
  timeline: "时间选择",
  indicator: "信息面板",
  risk: "风险值RV",
  buffer: "缓冲区",
  ice: "沿途冰情",
  weather: "温度变化趋势",
  flow: "通航风险计算流程",
  routeDate: "通航日期分析",
  step: "使用步骤",
  center: "选取计算中心点",
  order: "数据处理订单",
  archStep: "计算思路",
};

export const promiseDispatch = (dispatch, actionCreator, payload) =>
  new Promise((resolve, reject) =>
    dispatch(actionCreator({ params: payload, resolve, reject }))
  );

export const getLegendRanges = (layerGroup, category) => {
  if (!(layerGroup in legendRanges)) return null;
  const r = legendRanges[layerGroup];
  if (!(category in r)) return null;
  return legendRanges[layerGroup][category];
};

export const getDateRanges = (category) => {
  const months = [7, 8, 9, 10];
  const years = generateYears(category);

  let results = {};
  for (const y of years) {
    let ms = {};
    for (const m of months) {
      let days = [];
      const nod = getDaysInMonth(new Date(y, m, 0));
      for (let d = 1; d < nod + 1; d++) {
        days.push(d);
      }
      ms[m] = days;
    }
    results[y] = ms;
  }
  return results;
};

export const getDefaultYear = (category) => {
  if (category === "history") return 2012;
  else if (category === "irregular") return 2021;
  return 2025;
};

export const getDefaultMonth = (category) => {
  return 7;
};

export const getDefaultDay = () => {
  return 1;
};

const generateYears = (category) => {
  let years = [];
  if (category === "history") {
    for (let i = 2012; i < 2021; i++) {
      years.push(`${i}`);
    }
  } else if (category === "irregular") {
    years.push("2021", "2022");
  } else {
    for (let i = 2025; i < 2101; i++) {
      years.push(`${i}`);
    }
  }
  return years;
};

const getDaysInMonth = (date) =>
  new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate();

export const switchLayers = (
  layerGroup,
  category,
  year,
  month,
  day,
  panels,
  shipType,
  ranges = []
) => {
  if (!year || !month || !day) return null;
  const m = month < 10 ? `0${month}` : `${month}`;
  const d = day < 10 ? `0${day}` : `${day}`;
  switch (layerGroup) {
    case "concentration": {
      let name;
      if (category === "forecast") {
        name = `future_concentration_${year}-${m}-${d}`;
      } else if (category === "irregular") {
        name = `irregular_concentration_${year}-${m}-${d}`;
      } else {
        name = `concentration_${year}-${m}-${d}`;
      }
      return [
        {
          name: `arctic:${name}`,
          type: "wms",
          url: "/geoserver/arctic/wms",
        },
      ];
    }
    case "thickness": {
      let name;
      if (category === "forecast") {
        name = `future_thickness_${year}-${m}-${d}`;
      } else if (category === "irregular") {
        name = `irregular_thickness_${year}-${m}-${d}`;
      } else {
        name = `thickness_${year}-${m}-${d}`;
      }
      return [
        {
          name: `arctic:${name}`,
          type: "wms",
          url: "/geoserver/arctic/wms",
        },
      ];
    }
    case "route": {
      const visible1 = panels["risk"];
      const visible2 = panels["buffer"];
      let buffer, name, url;
      if (category === "forecast") {
        buffer = `${shipType}_future_passage_buffer_${year}-${m}-${d}`;
        name = `${shipType}_future_rv_${year}-${m}-${d}`;
        url = `/geojson/passage/forecast/${shipType}_future_passage_${year}-${m}-${d}.geojson`;
      } else if (category === "irregular") {
        buffer = `irregular_${shipType}_passage_buffer_${year}-${m}-${d}`;
        name = `irregular_${shipType}_rv_${year}-${m}-${d}`;
        url = `/geojson/passage/irregular/irregular_${shipType}_passage_${year}-${m}-${d}.geojson`;
      } else {
        buffer = `${shipType}_passage_buffer_${year}-${m}-${d}`;
        name = `${shipType}_rv_${year}-${m}-${d}`;
        url = `/geojson/passage/history/${shipType}_passage_${year}-${m}-${d}.geojson`;
      }
      let layers = [];
      if (visible1) {
        layers.push({
          name: `arctic:${name}`,
          type: "wms",
          url: "/geoserver/arctic/wms",
        });
      }
      if (visible2) {
        layers.push({
          name: `arctic:${buffer}`,
          type: "wms",
          url: "/geoserver/arctic/wms",
        });
      }
      if (ranges.includes(day)) {
        layers.push({
          name: `${year}_${m}_${d}`,
          type: "geojson",
          url,
        });
      }

      return layers;
    }
    case "temperature": {
      let name = `gfs_4_${year}${m}${d}_1200_000`;
      return [
        {
          name: `arctic:${name}`,
          type: "wms",
          url: "/geoserver/arctic/wms",
        },
      ];
    }
    case "wind": {
      return [{ type: "nc", name: "wind", url: `/geojson/nc/wind.nc` }];
    }
    default: {
      return null;
    }
  }
};

export const chunkArray = (array, chunkSize) => {
  return reduce(
    array,
    function (result, value) {
      var lastChunk = result[result.length - 1];
      if (lastChunk.length < chunkSize) lastChunk.push(value);
      else result.push([value]);
      return result;
    },
    []
  );
};

export const generateVertexes = (point1, point2) => {
  const bounds = L.latLngBounds([point1[1], point1[0]], [point2[1], point2[0]]);
  const sw = bounds.getSouthWest();
  const nw = bounds.getNorthWest();
  const ne = bounds.getNorthEast();
  const se = bounds.getSouthEast();
  return [
    [sw.lng, sw.lat],
    [nw.lng, nw.lat],
    [ne.lng, ne.lat],
    [se.lng, se.lat],
  ];
};

export const center = (points) => {
  if (points.length !== 2) {
    return [
      {
        name: ["longitude"],
        value: undefined,
      },
      {
        name: ["latitude"],
        value: undefined,
      },
    ];
  }
  const bounds = L.latLngBounds(
    [points[0][1], points[0][0]],
    [points[1][1], points[1][0]]
  );
  const c = bounds.getCenter();
  return [
    {
      name: ["longitude"],
      value: c.lng,
    },
    {
      name: ["latitude"],
      value: c.lat,
    },
  ];
};

export const guid = () => {
  return "xxxxxxxx".replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getFileName = (url) => {
  if (url) {
    var m = url.toString().match(/.*\/(.+?)\./);
    if (m && m.length > 1) {
      return m[1];
    }
  }
  return "";
};

export const pad = (number) => {
  return number < 10 ? `0${number}` : `${number}`;
};
